const ko = {
    '/': {
        title: '{brand} | 스포츠 베팅, 라이브 카지노 & 즉시 출금',
        description: '{brand}에서 슬롯, 라이브 카지노를 즐기고 스포츠에 베팅하세요. 즉시 출금, 증명 가능한 공정 게임 & 24/7 지원의 크립토 카지노.'
    },
    '/casino': {
        title: '온라인 카지노 | 슬롯, 블랙잭 & 라이브 딜러 | {brand}',
        description: '{brand}에서 슬롯, 블랙잭, 룰렛 & 라이브 딜러를 즐기세요. 수백 가지 게임, 빠른 크립토 입금 & 24/7 즉시 출금.'
    },
    '/sports': {
        title: '온라인 스포츠 베팅 | 크립토 스포츠 베팅 & 배당률 | {brand}',
        description: '{brand}에서 스포츠에 베팅하세요. 축구, 농구 등에 경쟁력 있는 배당률. 라이브 베팅, 안전한 크립토 베팅 & 빠른 지급.'
    },
    '/livecasino': {
        title: '라이브 카지노 | 블랙잭, 룰렛 & 라이브 딜러 | {brand}',
        description: '{brand}에서 블랙잭, 룰렛 & 라이브 카지노 게임을 즐기세요. 실제 딜러, HD 스트리밍 & 24/7 다양한 라이브 테이블.'
    },
    '/slots': {
        title: '온라인 슬롯 | 다양한 카지노 슬롯 | {brand}',
        description: '{brand}에서 방대한 슬롯 컬렉션을 돌려보세요. 클래식 머신, 비디오 슬롯 & 프로그레시브 – 모두 크립토로 플레이 가능.'
    },
    '/vip': {
        title: 'VIP 프로그램 | 독점 보상 & 혜택 | {brand}',
        description: '{brand}의 VIP 프로그램: 독점 보상, 개인화된 보너스, 우선 지원. 충성 플레이어를 위한 특별 혜택.'
    },
    '/welcome-offer': {
        title: '환영 오퍼 | 크립토 카지노 | {brand}',
        description: '{brand}의 환영 오퍼를 확인하세요. 크립토로 시작하고 신규 플레이어 전용 혜택을 즐기세요.'
    },
    '/referral': {
        title: '추천 프로그램 | 보상 획득 | {brand}',
        description: '친구를 {brand}에 초대하고 가입 및 조건 충족 시 보상을 받으세요. 추천 링크를 공유하고 수익을 시작하세요.'
    },
    '/promotion-page': {
        title: '프로모션 | 보너스 & 특별 오퍼 | {brand}',
        description: '{brand}의 모든 활성 프로모션. 크립토 플레이어를 위한 보너스, 무료 스핀, 특별 오퍼.'
    },
    '/hotslots': {
        title: '인기 슬롯 | 인기 카지노 슬롯 | {brand}',
        description: '{brand}에서 가장 인기 있는 슬롯 게임을 플레이하세요. 크립토로 즐길 수 있는 핫한 슬롯.'
    },
    '/newgames': {
        title: '새 게임 | 최신 카지노 게임 | {brand}',
        description: '{brand}에서 최신 카지노 게임을 확인하세요. 새로운 슬롯, 라이브 게임, 테이블 게임이 정기적으로 출시됩니다.'
    },
    '/populargames': {
        title: '인기 게임 | 가장 인기 있는 카지노 게임 | {brand}',
        description: '{brand}에서 가장 인기 있는 카지노 게임. 슬롯부터 라이브 게임까지 크립토로 모두 이용 가능.'
    },
    '/gameshows': {
        title: '게임쇼 | 라이브 게임쇼 카지노 | {brand}',
        description: '{brand}에서 라이브 게임쇼를 즐기세요. 진짜 진행자, 독특한 게임, 실시간 대형 당첨.'
    },
    '/table_games': {
        title: '테이블 게임 | 블랙잭, 룰렛 & 바카라 | {brand}',
        description: '{brand}에서 블랙잭, 룰렛, 바카라 등 테이블 게임을 즐기세요. 모두 크립토로 플레이 가능.'
    },
    '/hotlive': {
        title: '인기 라이브 카지노 | 인기 라이브 게임 | {brand}',
        description: '{brand}에서 가장 인기 있는 라이브 카지노 게임. 진짜 딜러와 실시간으로 게임하세요.'
    },
    '/featurebuyin': {
        title: '보너스 구매 슬롯 | Feature Buy-in | {brand}',
        description: '{brand}에서 보너스 라운드 구매 기능이 있는 슬롯을 플레이하세요. 기다리지 않고 바로 보너스 라운드로 진입.'
    },
    '/originals': {
        title: '오리지널 카지노 게임 | 독점 타이틀 | {brand}',
        description: '{brand}에서 독점 오리지널 게임을 플레이하세요. 다른 곳에서는 찾을 수 없는 자체 개발 타이틀로 비교할 수 없는 카지노 경험을 즐기세요.'
    },
    '/providers': {
        title: '게임 제공업체 | 파트너 스튜디오 & 소프트웨어 | {brand}',
        description: '{brand}의 모든 게임 제공업체를 탐색하세요. 최고의 스튜디오와 파트너십을 맺어 다양하고 고품질의 크립토 카지노 라이브러리를 제공합니다.'
    },
    '/about-us': {
        title: '회사 소개 | {brand}에 대해 알아보기',
        description: '선도적인 크립토 카지노 & 스포츠북 {brand}에 대해 알아보세요. 안전하고 공정하며 스릴 넘치는 게임과 즉시 크립토 출금에 전념합니다.'
    },
    '/affiliate': {
        title: '제휴 프로그램 | {brand}로 크립토 수익 창출',
        description: '{brand}의 파트너가 되어 크립토 카지노 홍보로 커미션을 받으세요. 경쟁력 있는 수수료율, 실시간 추적 & 전담 제휴 지원을 제공합니다.'
    },
    '/faq': {
        title: 'FAQ | 자주 묻는 질문 | {brand}',
        description: '{brand}에 관한 자주 묻는 질문에 대한 답변을 찾아보세요. 계정, 결제, 보너스 & 카지노 게임에 관한 FAQ를 확인하세요.'
    },
    '/aml-policy': {
        title: 'AML 정책 | {brand}의 자금세탁방지',
        description: '{brand}의 AML 정책은 안전하고 신뢰할 수 있는 환경을 보장합니다. 플랫폼에서의 불법 활동 방지 조치에 대해 읽어보세요.'
    },
    '/bonus-terms': {
        title: '보너스 이용약관 | {brand} 프로모션',
        description: '{brand}의 카지노 보너스 & 프로모션 규칙을 읽어보세요. 보너스 수령, 사용 & 보너스 당첨금 출금 방법을 확인하세요.'
    },
    '/complaints-and-arbitration': {
        title: '불만 및 중재 | {brand} 플레이어 지원',
        description: '{brand}의 불만 & 분쟁 해결 프로세스를 확인하세요. 공정한 처우를 보장하고 플레이어 문제를 신속하고 투명하게 해결합니다.'
    },
    '/fairness': {
        title: '검증 가능한 공정 게임 | {brand}의 공정성 보장',
        description: '{brand}는 검증 가능한 공정 기술을 사용하여 모든 게임 결과가 검증 가능하고 투명하며 완전히 무작위임을 보장합니다.'
    },
    '/fairness-overview': {
        title: '검증 가능한 공정 게임 개요 | {brand}',
        description: '{brand}의 검증 가능한 공정 시스템 설명. 모든 결과에서 게임 무결성 & 완전한 무작위성을 보장하는 암호화 원칙.'
    },
    '/kyc-policy': {
        title: 'KYC 정책 | {brand}의 고객 신원 확인',
        description: '{brand}의 KYC 정책은 신원 확인 프로세스를 설명합니다. 플레이어 보호 및 안전한 게임 환경 유지 방법을 확인하세요.'
    },
    '/payment-policy': {
        title: '결제 정책 | 크립토 입출금 | {brand}',
        description: '{brand}는 크립토 입출금을 지원합니다. 거래 한도, 허용 코인 & 처리 시간에 대한 결제 정책을 읽어보세요.'
    },
    '/privacy-policy': {
        title: '개인정보 처리방침 | {brand}의 데이터 보호',
        description: '{brand}의 개인정보 처리방침. 크립토 카지노 플랫폼에서 개인 데이터를 수집, 사용 & 보호하는 방법을 알아보세요.'
    },
    '/responsible-gaming': {
        title: '책임감 있는 게임 | {brand}에서 안전하게 플레이',
        description: '{brand}는 책임감 있는 도박을 위해 노력합니다. 게임 습관을 관리하고 안전하게 플레이하기 위한 도구 & 리소스에 접근하세요.'
    },
    '/terms-of-service': {
        title: '서비스 이용약관 | {brand}',
        description: '{brand} 이용을 규정하는 이용약관을 검토하세요. 플레이어로서의 권리와 책임을 이해하세요.'
    },
    '/terms-sports': {
        title: '스포츠 베팅 이용약관 | {brand}',
        description: '{brand}의 스포츠 베팅 이용약관. 베팅 배치, 당첨금 지급 & 플랫폼에서의 스포츠북 이용 규칙.'
    }
};
export default ko;
